import { create } from 'zustand'
import * as ChatTimelineAPI from '../../../API/ChatTimelineAPI'
import { devtools } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

const initialState = {
    timelineLoader: false,
    timelineData: {},
    timelineDataError: ''
}

const ChatTimelineStore = create(devtools(immer((set, get) => ({
    ...initialState,

    getTimelineByRiskId: async (riskId) => {
        set({ timelineLoader: true })
        try {
            const response = await ChatTimelineAPI.getTimelineByRiskId(riskId)
            if (response.data) {
                set({ ...initialState, timelineLoader: false, timelineData: response?.data })
            } else {
                set({ ...initialState, timelineLoader: false, timelineData: {} })
            }
        } catch (error) {
            set({ ...initialState, timelineDataError: error.message || 'An error occurred', timelineLoader: false, timelineData: {} })
        }
    }
}))))

export const useChatTimelineStore = ChatTimelineStore
